module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNav),
      expression: "showNav"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "row small-collapse",
    class: {
      'large-uncollapse': _vm.twoColumnsLayout
    }
  }, [_c('div', {
    staticClass: "small-12 column",
    class: {
      'large-8': _vm.twoColumnsLayout
    }
  }, [_c('router-view', {
    staticClass: "page-content"
  })], 1), _vm._v(" "), (_vm.twoColumnsLayout) ? _c('div', {
    staticClass: "search-column show-for-large large-4 column"
  }, [_c('router-view', {
    attrs: {
      "name": "search"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('app-footer', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFooter),
      expression: "showFooter"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63676bb4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 299
// module chunks = 2